import { EventEmitter } from 'events'
import Messages from './Messages'
import { logger } from './logger'


/**
 *
 *
 * @class Messenger
 * @classdesc This is to create a messenger
 *
 */
class Messenger extends EventEmitter {
  /**
   * Constructor of Messenger
   * @constructor
   * @param inputWindow
   * @param outputWindow
   * @param name
   * @param debug
   */
  constructor(inputWindow, outputWindow, name = 'unnamed', debug = false) {
    super()

    if (!inputWindow) {
      logger.warn('Missing parameter \'inputWindow\' in Messenger constructor, will default to current \'window\' object.')
    }
    this.inputWindow = inputWindow || window

    if (!outputWindow && this.inputWindow) {
      logger.warn('Missing parameter \'outputWindow\' in Messenger constructor, will default to inputWindow\'s parent window object.')
    }
    this.outputWindow = outputWindow || this.inputWindow.parent
    this.name = name
    this.debug = debug

    this.handleMessage = this.handleMessage.bind(this)
    this.inputWindow.addEventListener('message', this.handleMessage)
  }

  destroy() {
    this.inputWindow.removeEventListener('message', this.handleMessage)
  }

  handleMessage(messageEvent) {
    const expectedSource = messageEvent.source === this.outputWindow

    if (expectedSource) {
      if (this.debug) {
        const prefix = `[Messenger (${this.name})] handles message:`
        const separator = '--------------------'
        logger.info(separator)
        logger.group(prefix)
        logger.info(prefix)
        logger.info(`expectedSource: ${expectedSource}`)
        logger.info('message:', messageEvent.data)
        try {
          logger.log('e.source.name', messageEvent.source.name)
          logger.log('this.outputWindow', this.outputWindow.name)
        } catch (e) {
          logger.log(e.message)
        }
        logger.info(separator)
        logger.groupEnd(prefix)
      }

      const { data } = messageEvent
      // TODO: check if need below
      // let result = '';
      // try {
      //     result = eval(e.data);
      // } catch (e) {
      //     result = 'eval() threw an exception.';
      // }

      const {
        type, correlationId, payload, error
      } = data

      const eventMapping = {
        [Messages.CONNECT]: Messenger.ON_CONNECT,
        [Messages.CONNECTED]: Messenger.ON_CONNECTED,
        [Messages.DISCONNECT]: Messenger.ON_DISCONNECT,
        [Messages.DISCONNECTED]: Messenger.ON_DISCONNECTED,
        [Messages.DATA_REQUEST]: Messenger.ON_DATA_REQUEST,
        [Messages.DATA_RESPONSE]: Messenger.ON_DATA_RESPONSE,
        [Messages.COMMAND_REQUEST]: Messenger.ON_COMMAND_REQUEST,
        [Messages.COMMAND_RESPONSE]: Messenger.ON_COMMAND_RESPONSE,
        [Messages.DATA_TRANSFER]: Messenger.ON_DATA_TRANSFER,
      }

      let eventType = eventMapping[type]

      let eventPayload = { correlationId, payload }

      // The error received will be serialised data therefore it needs to be converted into an Error instance.
      const errorPayload = error ? new Error(error) : error

      if (!eventType) {
        eventType = Messenger.ON_UNKNOWN_MESSAGE
        eventPayload = data
      }

      this.emit(eventType, eventPayload, errorPayload)
    }
  }

  sendMessage(message) {
    // TODO: check if need JSON.stringify(message); ?
    // TODO: check if need to insert default stuff
    this.outputWindow.postMessage(message, '*');
  }
}

Messenger.ON_CONNECT = 'ON_CONNECT'
Messenger.ON_CONNECTED = 'ON_CONNECTED'
Messenger.ON_DISCONNECT = 'ON_DISCONNECT'
Messenger.ON_DISCONNECTED = 'ON_DISCONNECTED'
Messenger.ON_DATA_REQUEST = 'ON_DATA_REQUEST'
Messenger.ON_DATA_RESPONSE = 'ON_DATA_RESPONSE'
Messenger.ON_COMMAND_REQUEST = 'ON_COMMAND_REQUEST'
Messenger.ON_COMMAND_RESPONSE = 'ON_COMMAND_RESPONSE'
Messenger.ON_DATA_TRANSFER = 'ON_DATA_TRANSFER'
Messenger.ON_UNKNOWN_MESSAGE = 'ON_UNKNOWN_MESSAGE'

export default Messenger
